<template>
  <div class="bg-gray-200 h-screen">
    <loading :active.sync="loading"></loading>
    <div v-if="modal_password === false" class="w-full flex flex-col z-50 bg-gray-200 pt-4 pb-32">
      <h1 class="text-azuloscuro text-xl font-semibold text-center p-4 mb-16">Perfil</h1>

      <div class="mb-4 px-4">
        <div class="bg-white rounded-lg p-4 border border-gray-300">
          <div class="flex justify-center mx-auto mb-3 -mt-16">
            <div class="relative h-24 w-24 rounded-full overflow-hidden">
              <img
                v-if="user.profileImage"
                class="inline-block h-24 w-24 object-cover top-0"
                :src="getImageUrl"
              />

              <svg
                v-else
                class="inline-block h-24 w-24 object-cover top-0"
                xmlns="http://www.w3.org/2000/svg"
                width="512"
                height="512"
                viewBox="0 0 512 512"
              >
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M256,0C397.385,0,512,114.615,512,256S397.385,512,256,512,0,397.385,0,256,114.615,0,256,0Z"
                  fill="#020957"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M442.272,405.7a95.017,95.017,0,0,0-39.424-18.208l-70.176-14.08A15.827,15.827,0,0,1,320,357.728v-16.1c4.512-6.336,8.768-14.752,13.216-23.552,3.456-6.816,8.672-17.088,11.264-19.744,14.208-14.272,27.936-30.3,32.192-50.976,3.968-19.392.064-29.568-4.512-37.76,0-20.448-.64-46.048-5.472-64.672-.576-25.216-5.152-39.392-16.672-51.808-8.128-8.8-20.1-10.848-29.728-12.48-3.776-.64-8.992-1.536-10.912-2.56A112.927,112.927,0,0,0,255.328,64c-42.144,1.728-93.952,28.544-111.3,76.352-5.376,14.56-4.832,38.464-4.384,57.664l-.416,11.552c-4.128,8.064-8.192,18.3-4.192,37.76,4.224,20.7,17.952,36.768,32.416,51.232,2.368,2.432,7.712,12.8,11.232,19.648,4.512,8.768,8.8,17.152,13.312,23.456v16.1a15.9,15.9,0,0,1-12.736,15.68l-70.24,14.08a95.226,95.226,0,0,0-39.3,18.176,16.037,16.037,0,0,0-1.888,23.3A254.252,254.252,0,0,0,256,512c71.776,0,140.384-30.24,188.16-83.008a16.031,16.031,0,0,0-1.888-23.3Z"
                  fill="#eef1f6"
                />
              </svg>
              <div
                class="absolute inset-0 hover:bg-gray-700 hover:bg-opacity-50 text-transparent hover:text-white flex justify-center items-center cursor-pointer"
              >
                <input
                  type="file"
                  class="absolute opacity-0 w-full h-full top-0 left-0"
                  @change="handleFilesChosen"
                />
                <svg class="fill-current h-8 w-8" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <div class="text-azuloscuro text-center">{{user.name}} {{user.lastname}}</div>
            <div class="text-gray-500 text-center text-sm">{{user.email}}</div>
          </div>
          <div class="border rounded-lg mx-4 mt-6 pb-4 text-xs">
            <div class="text-center mt-5">
              <span class="text-gray-500 mr-3">Fecha de alta</span>
              <span class="text-azuloscuro">{{user.createdAt | date}}</span>
            </div>
            <div class="text-center mt-1" v-if="user.endDate">
              <span class="text-gray-500 mr-3">Fecha de finalización</span>
              <span class="text-azuloscuro">{{user.endDate | date}}</span>
            </div>
            <div class="text-center mt-1" v-if="user.group">
              <span class="text-gray-500 mr-3">Empresa</span>
              <span class="text-azuloscuro">{{user.group.name}}</span>
            </div>
            <div class="text-center mt-1">
              <span class="text-gray-500 mr-3">Pillpack</span>
              <span class="text-azuloscuro">{{user.latestPillpackName}}</span>
            </div>
          </div>

          <hr class="mt-5 mb-10" />

          <div class="flex justify-center mb-20">
            <div class="w-1/3 text-center">
              <div class="text-azuloscuro text-sm mb-3 leading-4">
                Pills
                <br />Completadas
              </div>
              <div
                class="shadow rounded-lg w-20 px-4 py-5 mx-auto flex justify-center items-center"
              >
                <span>{{ completedPills.length }}</span>
                <Zondicon
                  icon="checkmark"
                  class="fill-current text-verde inline-block h-3 line ml-1"
                />
              </div>
            </div>

            <div class="w-1/3 text-center">
              <div class="text-azuloscuro text-sm mb-3 leading-4">
                Pills
                <br />Pendientes
              </div>
              <div
                class="shadow rounded-lg w-20 px-4 py-5 mx-auto flex justify-center items-center"
              >
                <span>{{ pendingPills.length }}</span>
                <Zondicon
                  icon="adjust"
                  class="fill-current text-yellow inline-block h-3 line ml-1"
                />
              </div>
            </div>

            <div class="w-1/3 text-center">
              <div class="text-azuloscuro text-sm mb-3 leading-4">
                Pills
                <br />Favoritas
              </div>
              <div
                class="shadow rounded-lg w-20 px-4 py-5 mx-auto flex justify-center items-center"
              >
                <span>{{ user.favoriteCountInLatestPillpack || 0 }}</span>
                <Zondicon icon="heart" class="fill-current inline-block h-3 line ml-1" />
              </div>
            </div>
          </div>

          <div>
            <router-link to="/logout" class>
              <button
                class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                type="button"
              >Cerrar Sesión</button>
            </router-link>
            <div class="bg-red-100 border border-azuloscuro text-red-700 px-4 mt-4 py-3 rounded-lg relative" role="alert" v-if="passwordChangedMessage">
              <strong class="font-bold">Email de confirmación enviado</strong><br>
              <span class="block sm:inline">Recibirás un email para confirmar el cambio de contraseña.</span>
              <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          <svg @click="removeMessage" class="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
        </span>
            </div>
            <button
                    v-else
              class="bg-white border border-gray-500 hover:bg-gray-500 hover:text-white text-gray-500 py-2 px-4 rounded-full focus:outline-none w-full mt-4"
              type="button"
              @click.prevent="showPasswordModal"
            >Cambiar contraseña</button>
          </div>
        </div>
      </div>

      <Menu current="user"/>
    </div>

    <div v-if="modal_password === true" class="h-screen login-background">
      <div class="text-right">
        <button class="text-2xl mr-4 mb-2 mt-2" @click.prevent="showPasswordModal">x</button>
      </div>
      <div class="flex justify-center items-center">
        <div class="w-full max-w-sm px-2">
          <div class="logo mb-10">
            <img src="@/assets/logo.svg" />
          </div>

          <form class="px-8 pt-6 pb-8 mb-4" @submit.prevent="updatePassword">
            <div v-if="mensajeError != ''" class="bg-red text-white px-4 py-2 mb-4">
              <strong>Ha ocurrido un error.</strong>
              <span class="block sm:inline">{{ mensajeError }}</span>
            </div>

            <div v-if="mensajeExito != ''" class="bg-greenlight text-white px-4 py-2 mb-4">
              <strong>Excelente.</strong>
              <span class="block sm:inline">{{ mensajeExito }}</span>
            </div>

            <div
              class="text-azuloscuro text-2xl text-center leading-7 mb-10 font-semibold"
            >Introduce tu nueva contraseña</div>

            <div class="mb-6">
              <label class="block text-azulfondoclaro text-sm mb-2" for="form.new_password">Nueva Contraseña</label>
              <div class="form-input w-full pr-8 focus-within:shadow-outline relative field-wrapper">
                <input v-model="form.new_password" :type="showPassword ? 'text' : 'password'" class="w-full bg-gray-100 outline-none" required>
                <button type="button" class="cursor-pointer z-100 absolute right-0 top-0 bottom-0 my-2 mr-2" @click="toggleShowPassword()">
                  <Zondicon v-if="!showPassword" icon="view-show" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
                  <Zondicon v-else icon="view-hide" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
                </button>
              </div>
            </div>

            <div class="mb-6">
              <label class="block text-azulfondoclaro text-sm mb-2" for="form.new_password2">Repite Contraseña</label>
              <div class="form-input w-full pr-8 focus-within:shadow-outline relative field-wrapper">
                <input v-model="form.new_password2" :type="showPassword ? 'text' : 'password'" class="w-full bg-gray-100 outline-none" required>
                <div class="cursor-pointer z-100 absolute right-0 top-0 bottom-0 my-2 mr-2">
                  <Zondicon v-if="passwordsMatch" icon="checkmark" class="fill-current inline-block mr-1 text-green-700 loader" style="width: 24px"/>
                  <Zondicon v-else icon="close" class="fill-current inline-block mr-1 text-red loader" style="width: 24px"/>
                </div>
              </div>
            </div>

            <div class="flex justify-between mt-20">
              <button
                class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                type="submit"
                :class="{ 'hidden': datosCargados == false }"
              >Guardar</button>

              <button
                class="bg-gray-600 mr-2 text-sm font-semibold text-white py-2 px-4 rounded-full w-full"
                type="button"
                :class="{ 'hidden': datosCargados == true }"
              >Enviando datos...</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Utilities from "@/plugins/Utilities.js";
import users from "@/plugins/api/users/users.js";
import Zondicon from "vue-zondicons";
import Menu from "@/components/Menu";
import PillsLists from "@/plugins/PillsLists.js";
import pills from "@/plugins/api/pills/pills";
import auth from "@/plugins/api/users/auth";
import Loading from 'vue-loading-overlay';
import setTitle from "../plugins/title";

const Profile = {
  name: "Profile",
  layout: "layout",
  data: function() {
    return {
      user: {},
      modal_password: false,
      datosCargados: true,
      mensajeExito: "",
      mensajeError: "",
      form: {
        new_password: "",
        new_password2: ""
      },
      completedPills: [],
      pendingPills: [],
      loading: false,
      showPassword: false,
      passwordChangedMessage: false
    };
  },
  components: {
    Menu,
    Zondicon,
    Loading
  },
  methods: {
    removeMessage () {
      this.passwordChangedMessage = false
    },
    toggleShowPassword () {
      this.showPassword = !this.showPassword
    },
    async loadUser() {
      this.loading = true
      try {
        const response = await users.getSelfUser();
        this.user = response.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false
    },
    async loadPills() {
      pills
          .getPendingPills()
          .then(response => {
              this.pendingPills = response.data["hydra:member"];
          })
          .catch(e => {
              console.log(e);
          });
      pills
          .getCompletedPills().then(response => {
              this.completedPills = response.data["hydra:member"];
          })
          .catch(e => {
              console.log(e);
          });
    },
    async handleFilesChosen(event) {
      const file = event.target.files[0];
      const form = new FormData();

      form.append("image", file, file.name);

      const res = await users.uploadImage(form).then(async response => {
        this.user.profileImage = response.data.contentUrl;
      });
    },
    showPasswordModal() {
      this.modal_password = !this.modal_password;
    },
    async updatePassword(e) {
      this.datosCargados = false;
      this.mensajeExito = "";
      this.mensajeError = "";

      if (this.form.new_password != "" && (this.form.new_password == this.form.new_password2)) {
          var data = {
              "user": this.user['@id'],
              "password": this.form.new_password,
              "token": Math.random().toString(36).substr(2, 9)
          }
        await users.changePassword(data).then(response => {
          this.datosCargados = true;
          this.form.new_password = '';
          this.form.new_password2 = '';
          this.showPasswordModal();
          this.passwordChangedMessage = true;
        });
      } else {
        this.datosCargados = true;
        this.mensajeError =
          "Debe llenar correctamente todos los campos para poder cambiar la contraseña";
      }
    }
  },
  computed: {
    getImageUrl() {
      return auth.api.endpointPath.replace("api/v1/", "") + 'media/' +this.user.profileImage;
    },
    passwordsMatch () {
      return this.form.new_password === this.form.new_password2
    }
  },
  beforeMount: function() {
    if (!Utilities.isLogged()) {
      this.$router.push({ name: "login" });
      return;
    }

    this.loadUser();
    this.loadPills();
  },
  filters: {
    date: function(value) {
      return new Date(value).toLocaleDateString("es-ES");
    }
  },
  created () {
    setTitle('Perfil')
  }
};

export default Profile;
</script>

<style scoped>
  .field-wrapper {
    height: 36px;
    border-bottom: 2px solid rgb(226, 232, 240);
  }
</style>
